/* eslint-disable max-len */
import {bannerRate} from '@/static/pages/constants/buisnessDeposits';
import {
    itMortgageBank,
    mortgageTwoPercent,
} from '@/static/pages/constants/creditRates.js';

const metaParams = new Map(Object.entries({
    main: [
        'Коммерческий банк "Центр-инвест" | Банковские услуги физическим и юридическим лицам ',
        'Официальный сайт банка "Центр-инвест". Устойчивый банк для юга России. Кредиты на любые нужды, вклады, ипотека, рефинансирование | ПАО КБ "Центр-инвест"',
        'Банковские услуги физическим и юридическим лицам',
    ],
    about: [
        'Информация о банке ПАО КБ «Центр‑инвест»',
        'Информация, история, награды и социальные проекты ПАО коммерческий банк "Центр-инвест".',
        'Информация о банке ПАО КБ «Центр‑инвест»',
    ],
    'books-articles': [
        'Полезные книги и статьи от банка "Центр-инвест"',
        'Книги и статьи от банка "Центр-инвест" | Последние новости банка Центр-инвест для физических лиц и бизнеса',
        'Полезные книги и статьи от банка "Центр-инвест", Книги и статьи от банка "Центр-инвест"',
    ],
    'social-projects': [
        'Коммерческий банк "Центр-инвест" | Социальные проекты банка "Центр-инвест"',
        'Коммерческий банк "Центр-инвест" | Социальные проекты банка "Центр-инвест"',
        'Коммерческий банк "Центр-инвест" | Социальные проекты банка "Центр-инвест"',
    ],
    contacts: [
        'Контакт-центр ПАО КБ "Центр-инвест" - телефоны для физических и юридических лиц',
        'Контакты банка "Центр-инвест" для физических и юридических лиц • Круглосуточные телефоны • Вызов бесплатный • Пресс-центр',
        'Контакты',
    ],
    investors: [
        'Информация для акционеров и инвесторов банка "Центр-инвест"',
        'Полезная информация для акционеров и инвесторов банка "Центр-инвест" • Контакные данные для инвесторов и акционеров',
        'Акционерам и инвесторам',
    ],
    'shareholders-notices': [
        'Коммерческий банк "Центр-инвест" | Уведомления акционерам банка "Центр-инвест"',
        'Уведомления акционерам о размещении приобретенных акций | ПАО коммерческий банк Центр-инвест',
        'Коммерческий банк "Центр-инвест" | Уведомления акционерам банка "Центр-инвест"',
    ],
    'offices-and-atms': [
        'Офисы и банкоматы | банк "Центр-инвест"',
        'Расположение офисов и банкоматов банка "Центр-инвест" в Ростове-на-Дону и других городах России',
        'Офисы и банкоматы',
    ],
    agreement: [
        'Выписка по счету | Самоинкассация в банке Центр-инвест',
        'Подать заявку на доступ к сервисам печати выписок по счету онлайн и самоинкассации в банке Центр-инвест &#129534; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'выписка по счету, самоинкассация, выписка со счета, выписка счета онлайн, выписка с банковского счета, выписка с расчетного счета, самоинкассация онлайн, самоинкассация банки, выписка по счету и самоинкассация',
    ],
    business: [
        'Банковские услуги для юридических лиц | Банк Центр-инвест',
        'Банковские услуги для бизнеса. Выгодные предложения от банка Центр-инвест | Подробности на сайте и по телефону 8 800 200 99 30',
        'Бизнесу, Банк Центр-инвест',
    ],
    'payments-from-individuals': [
        'Прием платежей от физических лиц | Банк Центр-инвест',
        '&#127974; Банк Центр-инвест предоставляет услуги по приему платежей от физических лиц и ИП. Удобные и надежные способы оплаты. &#10004; &#129309; Надежность и профессионализм для вашего бизнеса. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'Бизнесу, Платежи от физических лиц, Банк Центр-инвест',
    ],
    acquiring: [
        'Выгодный эквайринг для бизнеса от банка Центр Инвест: Тарифы, Подключение, Обслуживание',
        '&#10004; Подключите эквайринг для вашего бизнеса в банке Центр Инвест. У нас вы найдете выгодные тарифы для ИП и юридических лиц, а также широкий спектр услуг по эквайрингу. &#127974; &#129309; Узнайте подробнее об оформлении, установке терминала и онлайн-кассы, а также об условиях и стоимости на нашем сайте или по телефону &#9742; 8 800 200 99 29',
        'торговый эквайринг, онлайн касса с эквайрингом, эквайринг для бизнеса, торговый эквайринг тарифы, торговый эквайринг для ип, заявка на эквайринг, эквайринг для малого бизнеса, торговый эквайринг подключить, эквайринг для бизнеса тарифы, эквайринг в бизнес онлайн, подать заявку на эквайринг',
    ],
    'bank-guarantees': [
        'Банковские гарантии для бизнеса | Банк Центр-инвест',
        '&#9989;Получить банковскую гарантию онлайн с выгодными условиями от банка Центр-инвест. Узнайте стоимость услуги, срочно оформите заявку и получите банковскую гарантию за 1 день. Поддержка для малого бизнеса и обеспечение исполнения контракта.&#129309;',
        'банковская гарантия банк, банковская гарантия стоимость, получить банковскую гарантию, заявка на банковскую гарантию, банковская гарантия онлайн, оформить банковскую гарантию, банковская гарантия цена, услуга банковской гарантии, банковская гарантия купить, банковская гарантия срочно, банковская гарантия помощь, получить банковскую гарантию на обеспечение исполнения контракта, банковская гарантия за 1 день, банковская гарантия для малого бизнеса, оформить банковскую гарантию срочно, оформить банковскую гарантию онлайн, банковская гарантия онлайн заявка, оформление банковской гарантии услуга, получить банковскую гарантию онлайн',
    ],
    'business-crediting': [
        'Кредиты для развития вашего бизнеса | Банк Центр-инвест для развития вашего стартапа',
        '&#10004; Взять кредит на развитие бизнеса от банка Центр-инвест. Мы предоставляем выгодные условия по кредитам для ИП, организаций и малых предприятий на развитие производств и стартапов. &#127974; Оставьте онлайн заявку на нашем сайте или свяжитесь с нами по телефону &#9742; 8 800 200 99 29 &#128200;',
        'кредит для бизнеса, кредит на развитие бизнеса, кредит для малого бизнеса, банки бизнес кредит, кредиты для бизнеса для ип, кредит под бизнес, взять кредит для бизнеса, кредит на бизнес условия, кредит для бизнеса онлайн',
    ],
    'avtomobilnyi-dlia-malogo-biznesa': [
        'Кредит «Автомобильный» для малого бизнеса | Банк Центр-инвест',
        'Кредит «Автомобильный» для малого бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит «Автомобильный» для малого бизнеса',
    ],
    'bankovskie-garantii': [
        'Банковские гарантии для бизнеса от 1% | Банк Центр-инвест',
        'Банковские гарантии для бизнеса | Все виды банковских гарантий, в том числе в рамках 44-ФЗ, 223-ФЗ | Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские гарантии для бизнеса',
    ],
    'biznes-kredit-dlia-zhenshchin': [
        'Бизнес-кредит для женщин | Банк Центр-инвест',
        'Бизнес-кредит для женщин. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Бизнес-кредит для женщин',
    ],
    'dlia-it-otrasli': [
        'Кредит для IТ отрасли | Банк Центр-инвест',
        'Кредит для IТ отрасли. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Для IТ отрасли',
    ],
    'investitsionnyi-kredit-dlia-modernizatsii-energoeffektivnykh-tekhnologii': [
        'Инвестиционный кредит для модернизации энергоэффективных технологий | Банк Центр-инвест',
        'Инвестиционный кредит для модернизации энергоэффективных технологий. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Инвестиционный кредит для модернизации энергоэффективных технологий',
    ],
    'ipoteka-dlia-it-spetsialistov': [
        'Ипотека для IT-специалистов | Банк Центр-инвест',
        'Ипотека для IT-специалистов. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Ипотека для IT-специалистов',
    ],
    'kommercheskaia-ipoteka': [
        'Коммерческая ипотека для бизнеса от банка Центр-инвест',
        '&#127974; Взять коммерческую ипотеку для бизнеса на выгодных условиях в банке Центр-инвест. &#128188; &#129309;Оформите ипотеку на коммерческую недвижимость онлайн для ИП, юридических лиц и малого бизнеса. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'Коммерческая ипотека',
    ],
    'kreditovanie-tszh-i-uk': [
        'Кредитование ТСЖ и УК | Банк Центр-инвест',
        'Кредитование ТСЖ и УК. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредитование ТСЖ и УК',
    ],
    'kredit-pod-kontrakt': [
        'Кредит на исполнение контракта | Банк Центр-инвест',
        'Кредит на исполнение контракта. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит на исполнение контракта',
    ],
    'lgotnye-kredity-apk': [
        'Льготные кредиты АПК | Банк Центр-инвест',
        'Льготные кредиты АПК. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготные кредиты АПК',
    ],
    'lgotnyi-kredit-dlia-malogo-i-srednego-biznesa': [
        'Льготный кредит для малого и среднего бизнеса | Банк Центр-инвест',
        'Льготный кредит для малого и среднего бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготный кредит для малого и среднего бизнеса',
    ],
    'lgotnyi-period-106-fz-i-restrukturizatsiia-kreditov': [
        'Льготный период 106-ФЗ и реструктуризация кредитов | Банк Центр-инвест',
        'Льготный период 106-ФЗ и реструктуризация кредитов. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготный период 106-ФЗ и реструктуризация кредитов',
    ],
    lizing: [
        'Лизинг для бизнеса | Банк Центр-инвест',
        'Лизинг для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Лизинг для бизнеса',
    ],
    'na-popolnenie-oborotnykh-sredstv': [
        'Кредит на пополнение оборотных средств для бизнеса | Банк Центр-инвест',
        'Кредит на пополнение оборотных средств для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит на пополнение оборотных средств для бизнеса',
    ],
    'na-priobretenie-selkhoztekhniki': [
        'Кредит на приобретение сельхозтехники для бизнеса | Банк Центр-инвест',
        'Кредит на приобретение сельхозтехники для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит на приобретение сельхозтехники для бизнеса',
    ],
    'onlain-kredit': [
        'Онлайн кредит для бизнеса | Банк Центр-инвест',
        'Онлайн кредит для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Онлайн кредит для бизнеса',
    ],
    overdraft: [
        'Овердрафт для бизнеса | Банк Центр-инвест',
        'Овердрафт для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Овердрафт для бизнеса',
    ],
    'psk-investitsionnaia': [
        'ПСК Инвестиционная | Банк Центр-инвест',
        'ПСК Инвестиционная. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'ПСК Инвестиционная',
    ],
    'psk-oborotnaia': [
        'ПСК Оборотная | Банк Центр-инвест',
        'ПСК Оборотная. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'ПСК Оборотная',
    ],
    'sezonnoe-kreditnoe-predlozhenie': [
        'Сезонное кредитное предложение для бизнеса | Банк Центр-инвест',
        'Сезонное кредитное предложение для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Сезонное кредитное предложение для бизнеса',
    ],
    'sotsialnaia-otvetstvennost': [
        'Кредит для социально ответственных предпринимателей | Банк Центр-инвест',
        'Социальная ответственность для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит для социально ответственных предпринимателей',
    ],
    startap: [
        'Кредит на стартап | Банк Центр-инвест',
        'Кредит на стартап. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит на стартап',
    ],
    'transformatsiia-biznesa': [
        'Кредит на трансформацию и диджитализацию бизнеса | Банк Центр-инвест',
        'Кредит на трансформацию и диджитализацию бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит на трансформацию и диджитализацию бизнеса',
    ],
    'tsifrovaia-transformatsiia-dlia-biznesa': [
        'Кредит на цифровую трансформацию для бизнеса | Банк Центр-инвест',
        'Кредит на цифровую трансформацию для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит на цифровую трансформацию для бизнеса',
    ],
    'client-bank': [
        'СДБО для бизнеса | Система Бизнес-онлайн от Банка Центр-инвест',
        '&#127974; Банк Центр-инвест предоставляет систему Бизнес-онлайн для юридических лиц с выгодными условиями по СДБО. Надежное решение для эффективного финансового управления. Подробности на сайте и по телефону &#9742; 8 800 200 99 29.',
        'клиент банк, банк клиент для юридических лиц, система клиент банк, система банк клиент для юридических лиц, система банк клиент онлайн, система клиент банк для бизнеса, сдбо, система дистанционного банковского обслуживания, сдбо для бизнеса, система дистанционного банковского обслуживания для бизнеса',
    ],
    'corporate-cards': [
        'Корпоративные карты для юридических лиц | Банк Центр-инвест',
        '&#128179; Получите корпоративную банковскую карту для юридических лиц от банка Центр-инвест. Удобные и эффективные расчетные и дебетовые корпоративные карты для вашего бизнеса. &#128188; &#128176; Управляйте финансами с уверенностью. Подробности на сайте и по телефону &#9742; 8 800 200 99 29.',
        'корпоративная карта, банковская корпоративная карта, корпоративная карта расчетная, корпоративные карты для юридических лиц, корпоративная банковская карта юридического лица, карта корпоративного клиента, корпоративная карточка, корпоративная дебетовая карта',
    ],
    'credit-holidays': [
        'Кредитные каникулы для физических лиц | Банк Центр-инвест',
        'Кредитные каникулы для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредитные каникулы для бизнеса',
    ],
    'credit-holidays-business': [
        'Реструктуризация кредитов и кредитные каникулы для бизнеса| Банк Центр-инвест',
        '&#127974;  Реструктуризация кредитов для ИП и кредитные каникулы для бизнеса в банке Центр-инвест. Управляйте финансами вашей компании с нашей поддержкой. &#129309; Подробности на сайте и по телефону &#9742; 8 800 200 99 29.',
        'Льготный период 106-ФЗ, реструктуризация кредитов',
    ],
    'energy-saving-investment': [
        'Стимулирование инвестиций в энергосбережение | Банк Центр-инвест',
        'Стимулирование инвестиций в энергосбережение. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Инвестиции в энергосбережение',
    ],
    leasing: [
        'Финансовый лизинг для бизнеса | Банк Центр-инвест',
        'Финансовый лизинг для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Финансовый лизинг',
    ],
    'opening-and-maintaining-account': [
        'Расчетно-кассовое обслуживание для юридических лиц и ИП|Банк Центр-инвест',
        '&#10004; &#129309; Откройте расчетный счет для бизнеса в банке Центр-инвест. Удобное и надежное расчетно-кассовое обслуживание (РКО) для юридических лиц и ИП на выгодных условиях. &#9742; 8 800 200 99 29',
        'открытие счета, открытие расчетного счета, расчетный счет для бизнеса, расчетный счет для бизнеса банки, открыть расчетный счет для бизнеса',
    ],
    'rko-special': [
        'Специальное предложение на открытие счёта для бизнеса | Банк Центр-инвест',
        'Специальное предложение на открытие счёта для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Открытие и ведение счета | Специальное предложение',
    ],
    'rko-currency': [
        'Расчетно-кассовое обслуживание в валюте |Банк Центр-инвест',
        '&#127974; Откройте расчетный счет в валюте и воспользуйтесь выгодным расчетно-кассовым обслуживанием (РКО) в банке Центр-инвест. &#10004; Получите доступ к валютным операциям и управляйте своими финансами с легкостью. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'рко в валюте, рко валютный, рко в юанях, расчетно кассовое обслуживание в валюте, валютное расчетно кассовое обслуживание',
    ],
    'placement-of-funds-and-securities': [
        'Депозиты для юридических лиц от банка Центр-инвест: выгодные ставки и разнообразие вкладов',
        `&#11088; Откройте депозиты для бизнеса онлайн с выгодными ставками до ${bannerRate} для ИП и юридических лиц. &#128188; &#128176; Узнайте больше о выгодных предложениях от банка Центр-инвест на нашем сайте и по телефону &#9742; 8 800 200 99 29.`,
        `депозиты для юридических лиц, депозиты для юридических лиц ставки, депозиты для бизнеса, депозиты для ип, депозит бизнес онлайн, депозиты индивидуальных предпринимателей, депозиты для малого бизнеса, депозит до ${bannerRate} процентов, депозиты до ${bannerRate} для бизнеса`,
    ],
    classic: [
        'Депозит «Классический»',
        `&#11088; Откройте депозиты для бизнеса онлайн с выгодными ставками до ${bannerRate} для ИП и юридических лиц. &#128188; &#128176; Узнайте больше о выгодных предложениях от банка Центр-инвест на нашем сайте и по телефону &#9742; 8 800 200 99 29.`,
        `депозиты для юридических лиц, депозиты для юридических лиц ставки, депозиты для бизнеса, депозиты для ип, депозит бизнес онлайн, депозиты индивидуальных предпринимателей, депозиты для малого бизнеса, депозит до ${bannerRate} процентов, депозиты до ${bannerRate} для бизнеса`,
    ],
    urgent: [
        'Депозит «Срочный»',
        `&#11088; Откройте депозиты для бизнеса онлайн с выгодными ставками до ${bannerRate} для ИП и юридических лиц. &#128188; &#128176; Узнайте больше о выгодных предложениях от банка Центр-инвест на нашем сайте и по телефону &#9742; 8 800 200 99 29.`,
        `депозиты для юридических лиц, депозиты для юридических лиц ставки, депозиты для бизнеса, депозиты для ип, депозит бизнес онлайн, депозиты индивидуальных предпринимателей, депозиты для малого бизнеса, депозит до ${bannerRate} процентов, депозиты до ${bannerRate} для бизнеса`,
    ],
    minimumBalance: [
        'Депозит «С неснижаемым остатком»',
        `&#11088; Откройте депозиты для бизнеса онлайн с выгодными ставками до ${bannerRate} для ИП и юридических лиц. &#128188; &#128176; Узнайте больше о выгодных предложениях от банка Центр-инвест на нашем сайте и по телефону &#9742; 8 800 200 99 29.`,
        `депозиты для юридических лиц, депозиты для юридических лиц ставки, депозиты для бизнеса, депозиты для ип, депозит бизнес онлайн, депозиты индивидуальных предпринимателей, депозиты для малого бизнеса, депозит до ${bannerRate} процентов, депозиты до ${bannerRate} для бизнеса`,
    ],
    comfort: [
        'Депозит «Комфортный»',
        `&#11088; Откройте депозиты для бизнеса онлайн с выгодными ставками до ${bannerRate} для ИП и юридических лиц. &#128188; &#128176; Узнайте больше о выгодных предложениях от банка Центр-инвест на нашем сайте и по телефону &#9742; 8 800 200 99 29.`,
        `депозиты для юридических лиц, депозиты для юридических лиц ставки, депозиты для бизнеса, депозиты для ип, депозит бизнес онлайн, депозиты индивидуальных предпринимателей, депозиты для малого бизнеса, депозит до ${bannerRate} процентов, депозиты до ${bannerRate} для бизнеса`,
    ],
    base: [
        'Депозит Базовый для бизнеса | Банк Центр-инвест',
        'Депозит Базовый для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Депозит Базовый для бизнеса',
    ],
    progressive: [
        'Депозит Прогрессивный для бизнеса | Банк Центр-инвест',
        'Депозит Прогрессивный для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Депозит Прогрессивный для бизнеса',
    ],
    'salary-projects': [
        'Зарплатный проект в банке Центр-инвест: выгодные условия и тарифы для юридических лиц',
        '&#128184;Откройте зарплатный счет в банке Центр-инвест и воспользуйтесь нашими выгодными условиями для юридических лиц. &#127974; &#129309; Узнайте о тарифах и преимуществах нашего зарплатного проекта на сайте банка или по телефону &#9742; 8 800 200 99 29.',
        'зарплатный проект, зарплатный проект банки, зарплатный проект бизнеса, зарплатный проект онлайн, зарплатный проект для ип, зарплатный проект условия, тарифы зарплатный проект, зарплатный проект для бизнеса',
    ],
    'self-employed': [
        'Кредиты для самозанятых граждан на развитие бизнеса | Банк Центр-инвест',
        '&#127974; Взять кредит самозанятому в банке Центр-инвест на выгодных условиях. Оформите кредит онлайн и получите необходимое финансирование для вашего бизнеса. Подайте заявку прямо сейчас! &#10004; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'кредит для самозанятых, банк для самозанятых кредит, кредит наличными для самозанятых, кредит наличными для самозанятых граждан',
    ],
    'trade-finance': [
        'Торговое финансирование бизнеса | Банк Центр-инвест',
        '&#128184; Торговое и внешнеторговое финансирование бизнеса на выгодных условиях от банка Центр-инвест. Узнайте больше о наших финансовых решениях для развития вашего бизнеса. &#10004; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'торговое финансирование, торговое финансирование банки, внешнеторговое финансирование',
    ],
    'deposit-insurance': [
        'Страхование вкладов | ПАО коммерческий банк Центр-инвест',
        'ПАО КБ «Центр-инвест» включен в реестр банков-участников системы обязательного страхования вкладов 9 декабря 2004 года. Ваши вклады надежно застрахованы!',
        'Страхование вкладов',
    ],
    esg: [
        'Бизнес-модель ESG-банкинга "Центр-инвест"',
        'Социальные, образовательные, экологические, благотворительные программы банка «Центр-инвест» сегодня охватывают 6 регионов страны и более 700 000 человек.',
        'ESG, Акционерам и инвесторам',
    ],
    'for-individuals': [
        'Банковские услуги для физических лиц | Банк Центр-инвест',
        'Банковские услуги для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
    ],
    'biometric-data': [
        'Сбор и размещение биометрических данных клиента для физических лиц | Банк Центр-инвест',
        'Сбор и размещение биометрических данных клиента для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Биометрические данные',
    ],
    'card-features': [
        'Возможности карты «Центр-инвест» для физических лиц | Банк Центр-инвест',
        'Возможности карты «Центр-инвест» для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Возможности карты',
    ],
    'mir-pay': [
        'Приложение Mir Pay для физических лиц | Банк Центр-инвест',
        'Приложение Mir Pay для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Mir Pay',
    ],
    'concierge-service': [
        '«Консьерж»-сервис для физических лиц | Банк Центр-инвест',
        '«Консьерж»-сервис для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        '«Консьерж»-сервис',
    ],
    'debet-cards': [
        'Дебетовые карты – заказать дебетовую карту для физических лиц в банке Центр-инвест',
        'Дебетовые карты с быстрым оформлением в банке Центр-инвест. &#9989; Заказать банковскую карту онлайн. Бесплатное обслуживание, кэшбек и процент на остаток.  Выбрать и оформить дебетовую карту можно на сайте или по телефону &#9742; 8 800 200 99 29',
        'заказать дебетовую карту, заказать дебетовую карту банка, выгодные дебетовые карты, дебетовые карты для физических лиц, выбрать дебетовую карту, выбрать лучшую дебетовую карту',
    ],
    advanced: [
        'Продвинутая карта для физических лиц | Банк Центр-инвест',
        'Продвинутая карта для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Продвинутая карта для физических лиц',
    ],
    exclusive: [
        'Эксклюзивная карта для физических лиц | Банк Центр-инвест',
        'Эксклюзивная карта для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Эксклюзивная карта для физических лиц',
    ],
    'mir-supreme': [
        'Карта Mir Supreme для физических лиц | Банк Центр-инвест',
        'Карта Mir Supreme для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Карта Mir Supreme для физических лиц',
    ],
    'mir-supreme-plus': [
        'Карта Mir Supreme+ для физических лиц | Банк Центр-инвест',
        'Карта Mir Supreme+ для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Карта Mir Supreme+ для физических лиц',
    ],
    'narod-mir': [
        'Народная карта «Мир» для физических лиц | Банк Центр-инвест',
        'Народная карта «Мир» для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Народная карта «Мир» для физических лиц',
    ],
    'karta-bolelshchika-futbolnogo-kluba-chaika': [
        'Карта болельщика футбольного клуба "Чайка" | Банк Центр-инвест',
        // TODO: put the bet in a single file
        'Карта болельщика футбольного клуба "Чайка" | Банк Центр-инвест | 12% годовых на остаток по карте | Платежная система "Мир"',
        'Карта болельщика футбольного клуба "Чайка", Банк Центр-инвест',
    ],
    'gk-rostov-card': [
        'Карта болельщика гандбольного клуба "Ростов-Дон" | Банк Центр-инвест',
        // TODO: put the bet in a single file
        'Карта болельщика гандбольного клуба "Ростов-Дон" | Банк Центр-инвест | 12% годовых на остаток по карте | Платежная система "Мир"',
        'Карта болельщика гандбольного клуба "Ростов-Дон" | Банк Центр-инвест',
    ],
    premium: [
        'Премиальная карта | Банк Центр-инвест',
        'Премиальная карта для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Премиальная карта для физических лиц',
    ],
    univ: [
        'Универсальная карта | Банк Центр-инвест',
        'Универсальная карта для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Универсальная карта для физических лиц',
    ],
    mir: [
        'Универсальная карта "Мир" | Банк Центр-инвест',
        'Универсальная карта "Мир" для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Универсальная карта "Мир" для физических лиц',
    ],
    pens: [
        'Пенсионная дебетовая карта МИР от банка Центр-инвест',
        '&#10004; Оформить пенсионную карту онлайн удобно с банком Центр-инвест. Откройте пенсионную дебетовую карту МИР и управляйте своими средствами легко. &#128221; Выгодный процент - получайте до 16% на остаток. Оставьте онлайн-заявку на нашем сайте, а дополнительную информацию можно узнать по телефону  &#9742; 8 800 200 99 29.',
        'пенсионная карта, пенсионная карта мир, банк карта мир пенсионная, оформить пенсионную карту онлайн, открыть пенсионную карту мир, карта мир пенсионная оформить онлайн',
    ],
    'selfemployed-card': [
        'Карта для самозанятого от банка Центр-инвест',
        'Оформить банковскую карту для самозанятых граждан в банке Центр-инвест &#127974; Выгодные условия, кэшбэк до 30 процентов &#129534; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'самозанятый карта, карта для самозанятого, самозанятый оформить карту, банковская карта для самозанятых, карты для самозанятых граждан, карта для самозанятых для физических лиц',
    ],
    docs: [
        'Документы по банковским картам для физических лиц | Банк Центр-инвест',
        'Документы по банковским картам для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Документы по банковским картам',
    ],
    'rerelease-card': [
        'Перевыпуск карты для физических лиц | Банк Центр-инвест',
        'Перевыпуск карты для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Перевыпуск карты',
    ],
    'additional-card': [
        'Выпуск дополнительной карты для физических лиц | Банк Центр-инвест',
        'Выпуск дополнительной карты для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Выпуск дополнительной карты',
    ],
    security: [
        'Безопасное использование карточки для физических лиц | Банк Центр-инвест',
        'Безопасное использование карточки для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Безопасность',
    ],
    'student-cards': [
        'Банковская карта для студентов от Центр-инвест',
        '&#10145; Предлагаем открыть студенческую карту в банке Центр-инвест. &#9989; Оставить заявку на оформление банковской карты для студентов онлайн.',
        'банковская карта для студентов, студенческая карта банка',
    ],
    donstu: [
        'Банковские карты для студентов ДГТУ | Банк Центр-инвест',
        'Банковские карты для студентов ДГТУ. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов ДГТУ',
    ],
    iwtsedov: [
        'Банковские карты для студентов ИВТ им. Г.Я. | Банк Центр-инвест',
        'Банковские карты для студентов ИВТ им. Г.Я.. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов ИВТ им. Г.Я.',
    ],
    kubstu: [
        'Банковские карты для студентов КубГТУ | Банк Центр-инвест',
        'Банковские карты для студентов КубГТУ. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов КубГТУ',
    ],
    mgtu: [
        'Банковские карты для студентов МГТУ | Банк Центр-инвест',
        'Банковские карты для студентов МГТУ. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов МГТУ',
    ],
    npi: [
        'Банковские карты для студентов HПИ | Банк Центр-инвест',
        'Банковские карты для студентов HПИ. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов HПИ',
    ],
    ranepa: [
        'Банковские карты для студентов РАНХиГС | Банк Центр-инвест',
        'Банковские карты для студентов РАНХиГС. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов РАНХиГС',
    ],
    rgups: [
        'Банковские карты для студентов РГУПС | Банк Центр-инвест',
        'Банковские карты для студентов РГУПС. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов РГУПС',
    ],
    rsk: [
        'Банковские карты для студентов РСК | Банк Центр-инвест',
        'Банковские карты для студентов РСК. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов РСК',
    ],
    rsue: [
        'Банковские карты для студентов РГЭУ (РИНХ) | Банк Центр-инвест',
        'Банковские карты для студентов РГЭУ (РИНХ). Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов РГЭУ (РИНХ)',
    ],
    sfedu: [
        'Банковские карты для студентов ЮФУ | Банк Центр-инвест',
        'Банковские карты для студентов ЮФУ. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Банковские карты для студентов ЮФУ',
    ],
    crediting: [
        'Кредитование для физических лиц, взять кредит в банке Центр-инвест',
        '&#10145; Центр-инвест осуществляет кредитование физических лиц по выгодной процентной ставке. &#9989; На странице вы можете рассчитать ежемесячный платеж по кредиту и подать заявку на кредит онлайн.',
        'кредит для физических лиц, банки кредиты физическим лицам, кредитование физических лиц, взять кредит физическому лицу, банк кредитование физических лиц',
    ],
    'car-loans': [
        'Автокредит в банке Центр-инвест - Взять автомобиль в кредит на выгодных условиях ',
        '&#128664; Взять автокредит или воспользоваться услугой рефинансирования автокредита можно в банке Центр-инвест. &#10004; Удобный онлайн-калькулятор для расчета условий кредитования доступен для физических лиц. Подайте заявку прямо сейчас!',
        'автокредит, автокредит банк, взять автокредит в банке',
    ],
    'consumer-loan': [
        'Взять потребительский кредит для физических лиц | Банк Центр-инвест',
        'Оформите потребительский кредит в банке Центр-инвест. &#10004; Ознакомьтесь с условиями кредитования на любые цели для физических лиц  и подайте заявку онлайн на нашем сайте или позвоните по телефону &#9742; 8 800 200 99 29.',
        'кредит наличными, банк кредит наличными, взять кредит наличными, кредит наличными онлайн, взять кредит в банке наличными, кредит на любые цели, кредит наличными на любые цели, взять кредит на любые цели, кредит на любые цели онлайн',
    ],
    'credit-for-all': [
        'Потребительский  кредит на любые цели в банке Центр-инвест',
        'Взять кредит на любые цели в банке Центр-инвест. &#10004; Удобный онлайн-калькулятор поможет вам рассчитать условия кредитования для физических лиц. Чтобы выгодно получить кредит на любые цели подайте заявку прямо на сайте или по телефону &#9742; 8 800 200 99 29.',
        'Кредит наличными на любые цели',
    ],
    'credit-marketplace': [
        'Online кредит для физических лиц | Банк Центр-инвест',
        'Online кредит для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит МАРКЕТПЛЕЙС',
    ],
    'credit-cards': [
        'Оформить кредитную карту онлайн | Банк Центр-инвест',
        '&#10145; Оформить кредитную карту от банка Центр-инвест. &#9989; Оставить онлайн заявку на выгодную кредитную карту на сайте или по телефону &#9742; 8 800 200 99 29.',
        'оформить кредитную карту, оформить кредитную карту онлайн, оформить кредитную карту банка, оформить кредитную карту банка онлайн, подобрать кредитную карту, подобрать кредитную карту онлайн',
    ],
    'paket-dokumentov': [
        'Пакет документов для рассмотрения заявления на кредит для физических лиц | Банк Центр-инвест',
        'Пакет документов для рассмотрения заявления на кредит для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Пакет документов для рассмотрения заявления на кредит',
    ],
    'remote-payment-methods-for-loans': [
        'Дистанционные способы оплаты кредитов для физических лиц | Банк Центр-инвест',
        'Дистанционные способы оплаты кредитов для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Дистанционные способы оплаты кредитов',
    ],
    'repayment-credits': [
        'Реструктуризация кредитов физических лиц, подать заявку на кредитные каникулы',
        '&#10145; Предлагаем реструктуризацию кредитов физических лиц или кредитные каникулы в банке Центр-инвест. &#9989; Рассчитать условия реструктуризации кредита в банке или подать заявку на кредитнве каникула онлайн. &#11088; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'реструктуризация кредитов физических лиц, реструктуризация кредита в банке физическому лицу',
    ],
    'zelenaia-ipoteka-dlia-biznesa': [
        'Зеленая ипотека для бизнеса | Банк Центр-инвест',
        'Зеленая ипотека для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Зеленая ипотека для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
    ],
    'fz-credit': [
        'Льготный период по 106-ФЗ для физических лиц | Банк Центр-инвест',
        'Льготный период по 106-ФЗ для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготный период по 106-ФЗ для физических лиц',
    ],
    'fz-mortgage': [
        'Льготный период по 353-ФЗ для физических лиц | Банк Центр-инвест',
        'Льготный период по 353-ФЗ для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготный период по 353-ФЗ для физических лиц',
    ],
    restructuring: [
        'Реструктуризация кредитов для физических лиц | Банк Центр-инвест',
        'Реструктуризация кредитов для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Реструктуризация кредитов для физических лиц',
    ],
    'service-tariffs': [
        'Тарифы на услуги по обслуживанию кредитов для физических лиц | Банк Центр-инвест',
        'Тарифы на услуги по обслуживанию кредитов для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Тарифы на обслуживание',
    ],
    'currency-rates': [
        'Курсы валют | Банк Центр-инвест',
        'Курсы валют. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Курсы валют',
    ],
    deposits: [
        'Вклады для физических лиц в банке Центр-инвест',
        'Откройте вклад для физических лиц под высокий процент в банке Центр-инвест. &#10004; Все вклады застрахованы. Узнайте подробнее об условиях открытия банковских вкладов на сайте или звоните по телефону &#9742; 8 800 200 99 29.',
        'вклады для физических лиц, вклады в банках для физических лиц, открыть вклад в банке, открыть вклад в банке под проценты',
    ],
    profitable: [
        'Открыть вклад в рублях для физических лиц в банке Центр-инвест',
        '&#10145; Откройте выгодный вклад в рублях в банке Центр-инвест. &#9989; На странице можно подобрать банковский вклад в рублях под высокие проценты физическому лицу и подать онлайн заявку на рублевый вклад.',
        'вклады в рублях, вклады для физических лиц в рублях, выгодные вклады в рублях в банках, открыть вклад в рублях, банковские вклады в рублях, открыть вклад в рублях выгодно, открыть вклад под проценты в рублях, открыть банковский вклад в рублях',
    ],
    'currency-deposits': [
        'Валютные вклады для физических лиц | Банк Центр-инвест',
        'Валютные вклады для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Валютные вклады для физических лиц',
    ],
    'internet-bank-service': [
        'Интернет-Банк от банка Центр-инвест',
        'Интернет-Банк для физических лиц от банка Центр-инвест &#127974; Управляйте Вашими средствами на счете через сервис на сайте с компьютера &#128187; или мобильного устройства &#128241; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'интернет банк, интернет банки для физических лиц, мобильные интернет банки, сайт интернет банка, сервис интернет банк',
    ],
    'mobile-bank': [
        'Мобильный банк от банка Центр-инвест',
        '&#127974; На сайте банка Центр-инвест можно скачать бесплатное приложение Мобильный банк на андроид и другие телефоны &#128241; Подробнее как подключить мобильный банк онлайн для физических лиц на сайте или по телефону &#9742; 8 800 200 99 29',
        'мобильный банк, мобильный банк телефоны, скачать бесплатное приложение мобильный банк, скачать мобильный банк на андроид, мобильные банки на телефоне, как подключить мобильный банк, мобильный банк онлайн, мобильный банк для физических лиц, где скачать мобильный банк, как войти в мобильный банк',
    ],
    'money-transfers': [
        'Денежные переводы для физических лиц | Банк Центр-инвест',
        'Денежные переводы для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Денежные переводы для физических лиц',
    ],
    'golden-crown': [
        'Денежные переводы «Золотая Корона» для физических лиц | Банк Центр-инвест',
        'Денежные переводы «Золотая Корона» для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Денежные переводы «Золотая Корона» для физических лиц',
    ],
    internetbank: [
        'Демонстрационная версия интернет-банкинга | Банк Центр-инвест',
        'Демонстрационная версия интернет-банкинга для ознакомления с функционалом | Банк Центр-инвест',
        'Демонстрационная версия интернет-банкинга, Банк Центр-инвест',
    ],
    'payments-doc-list': [
        'Информационное пособие по использованию личного кабинета | Банк Центр-инвест',
        'Информационное пособие по использованию личного кабинета | Банк Центр-инвест',
        'Информационное пособие по использованию личного кабинета | Банк Центр-инвест',
    ],
    mortgage: [
        'Оформить ипотеку в банке Центр-инвест - онлайн заявка на ипотеку, программы ипотечного кредитования',
        'Взять ипотеку на жилье на выгодных условиях в банке Центр-инвест. Онлайн оформление заявки на ипотечный кредит. &#9989; Большой выбор программ ипотеки под низкий процент. Рассчитать ипотеку онлайн и подать заявку можно на сайте. &#11088; Подробности по телефону &#9742; 8 800 200 99 29',
        'ипотека банк, рассчитать ипотеку онлайн, ипотека для физических лиц, взять ипотеку банки, ипотека онлайн заявка',
    ],
    building: [
        'Ипотека на строительство дома в банке Центр-инвест',
        'Оформите ипотеку под строительство частного дома или покупку земли с банком Центр-инвест. &#10004; Рассчитайте условия кредитования прямо на сайте и подайте заявку на кредит под строительство дома. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'ипотека на строительство дома, ипотека на строительство частного дома, взять ипотеку на строительство дома, банк ипотека на строительство дома, заявка на ипотеку на строительство дома, подать заявку на ипотеку на строительство дома',
    ],
    'commercial-property': [
        'Ипотека на коммерческую недвижимость для физических лиц в банке Центр-инвест',
        'Оформите ипотеку на коммерческую недвижимость на выгодных условиях в банке Центр-инвест. &#9989; Рассчитать платеж ипотечного кредита и взять коммерческую ипотеку онлайн можно на сайте. &#11088; Подробности по телефону &#9742; 8 800 200 99 29',
        'ипотека на коммерческую недвижимость, коммерческая ипотека для физических, коммерческая ипотека для физических лиц, коммерческая ипотека банки',
    ],
    'it-mortgage': [
        'Ипотека для IT-специалистов с льготной господдержкой — оформить льготную ипотеку для сотрудников ИТ компаний в банке Центр-инвест',
        'Оформите льготную ипотеку для ИТ-Специалистов (с господдержкой - ПП РФ 805) в 2025 году. &#9989; Удобный онлайн-калькулятор для расчета ипотеки с господдержкой доступен для сотрудников айти компаний. Узнайте условия и подайте заявку прямо сейчас. &#11088; Подробности на сайте или по телефону &#9742; 8 800 200 99 29.',
        'ит ипотека, ипотека для ит специалистов, льготная ипотека для ит, льготная ипотека для ит специалистов, ипотека с господдержкой для ит',
    ],
    'it-mortgage-bank': [
        `Условия ипотеки для ИТ специалистов под ${itMortgageBank.rate}%`,
        '&#10145; Предлагаем выгодные условия по ипотеке для ИТ специалистов от банка Центр-инвест. &#9989; Рассчитать условия по ИТ-ипотеке онлайн и подать заявку на получение ипотеки IT-специалисту. &#11088; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'ит ипотека условия, ит ипотека банк, ипотека для ит специалистов условия, заявка на ит ипотеку, подать заявку на ит ипотеку',
    ],
    'maternal-capital': [
        'Погашение кредита материнским капиталом | Банк Центр-инвест',
        'Погашение кредита материнским капиталом. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Погашение кредита материнским капиталом',
    ],
    'mortgage-children': [
        'Семейная ипотека 2025 — оформить льготную ипотеку с господдержкой для семей с детьми в банке Центр-инвест',
        'Оформите семейную ипотеку 2025 в банке Центр-инвест. &#10004; Удобный онлайн-калькулятор для расчета семейной ипотеки. Выгодные условия семейной ипотеки, низкая процентная ставка, срок до 30 лет. Оставьте онлайн-заявку на сайте или свяжитесь по телефону &#9742; 8 800 200 99 29.',
        'семейная ипотека, ипотека для семей с детьми, банк семейная ипотека, заявка на семейную ипотеку, подать заявку на семейную ипотеку',
    ],
    village: [
        'Подать заявку на сельскую ипотеку онлайн | Банк Центр-инвест',
        '&#10145; Банк Центр-инвест предлагает взять сельскую ипотеку. &#9989; Рассчитать условия ипотечного кредита на сельских территориях и подать заявку на сельскую ипотеку онлайн. &#11088; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'сельская ипотека, заявка на сельскую ипотеку, подавать заявку на сельскую ипотеку, подать заявку на сельскую ипотеку, сельская ипотека онлайн заявка, сельская ипотека подать заявку онлайн',
    ],
    'online-applications': [
        'Онлайн - сервисы | Банк Центр-инвест',
        'Онлайн - сервисы. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Онлайн-сервисы',
    ],
    'reference-information': [
        'Справочная информация для физических лиц | Банк Центр-инвест',
        'Справочная информация для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Справочная информация',
    ],
    refinancing: [
        'Расчет рефинансирования кредитов | Банк Центр-инвест, калькулятор',
        '&#10145; Предлагаем выгодные условия рефинансирования кредитов в банке Центр-инвест. &#9989; Расчет рефинансирования для физических лиц на калькуляторе онлайн. Возможность рефинансирования кредитов в других банках. &#11088; Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'рефинансирование кредита, банк рефинансирование кредитов, расчет рефинансирования кредита, расчет рефинансирования кредита калькулятор',
    ],
    'credit-refinancing': [
        'Рефинансирование потребительских кредитов | Банк Центр-инвест',
        '&#10145; Предлагаем выгодные условия рефинансирования потребительских кредитов в банке Центр-инвест. &#9989; Оставьте заявку онлайн на сайте или по телефону &#9742; 8 800 200 99 29',
        'рефинансирование потребительских кредитов, рефинансирование потребительского кредита банк',
    ],
    'mortgage-refinancing': [
        'Рефинансирование ипотеки в банке Центр-инвест &#10004;',
        'Рефинансировать ипотеку на выгодных условиях в банке Центр-инвест, быстрое рассмотрение заявки онлайн, низкая ставка, без страхования &#11088; Удобно рассчитать на калькуляторе рефинансирования ипотеки. Подать заявку на рефинансирование на сайте или по телефону &#9742; 8 800 200 99 29',
        'рефинансирование ипотеки, банк рефинансирование ипотеки, условия рефинансирования ипотеки, заявка на рефинансирование ипотеки, рефинансирование ипотеки рассчитать онлайн, подать заявку на рефинансирование ипотеки',
    ],
    'safe-boxes': [
        'Индивидуальные сейфовые ячейки для физических лиц | Банк Центр-инвест',
        'Индивидуальные сейфовые ячейки для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Индивидуальные сейфовые ячейки',
    ],
    'sale-of-coins': [
        'Монеты из драгоценных металлов | Банк Центр-инвест',
        'Монеты из драгоценных металлов. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Монеты из драгоценных металлов',
    ],
    securities: [
        'Ценные бумаги | Банк Центр-инвест',
        'Ценные бумаги. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Ценные бумаги',
    ],
    'service-rates': [
        'РКО физических лиц | Банк Центр-инвест',
        'РКО физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'РКО физических лиц',
    ],
    'currency-rf': [
        'Расчетно-кассовое обслуживание (операции в валюте РФ) для физических лиц | Банк Центр-инвест',
        'Расчетно-кассовое обслуживание (операции в валюте РФ) для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Расчетно-кассовое обслуживание (операции в валюте РФ)',
    ],
    'foreign-currency': [
        'Расчетно-кассовое обслуживание (операции в иностранной валюте) для физических лиц | Банк Центр-инвест',
        'Расчетно-кассовое обслуживание (операции в иностранной валюте) для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Расчетно-кассовое обслуживание (операции в иностранной валюте)',
    ],
    'tariff-terminals': [
        'Тарифы на обслуживание физических лиц в устройствах самообслуживания | Банк Центр-инвест',
        'Тарифы на обслуживание физических лиц в устройствах самообслуживания. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Тарифы на обслуживание физических лиц',
    ],
    'vip-service': [
        'ВИП обслуживание в банке Центр-инвест',
        '&#127974; Банк Центр-инвест предоставляет VIP обслуживание для физических лиц. Большой выбор выгодных предложений. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'вип обслуживание, vip обслуживание, вип обслуживание банки, обслуживание вип клиентов, обслуживания vip клиентов, премиум обслуживание для физических лиц, вип обслуживание для физических лиц, vip обслуживание банки, vip обслуживание физических лиц',
    ],
    nadzorniy_organ: [
        'Банковский надзор за деятельностью кредитной организации ПАО КБ «Центр-инвест»',
        'Подробная информация о банковском надзоре за деятельностью кредитной организации ПАО КБ «Центр-инвест»',
        'Надзорный орган',
    ],
    processing_agreement: [
        'Положение об обработке персональных данных | ПАО КБ «Центр-инвест»',
        'Положение об обработке персональных данных ПАО КБ «Центр-инвест» за 2022 год.',
        'Положение об обработке персональных данных',
    ],
    career: [
        'Как устроиться на работу в банке "Центр-инвест"',
        'Работа в банке "Центр-инвест". Как устроиться на работу в наш банк? Стажировка и последующее трудоустройство в ПАО КБ "Центр-инвест".',
        'Как устроиться на работу в банке "Центр-инвест"',
    ],
    'medical-professionals': [
        'Индивидуальные условия кредитования для работников медицинской сферы',
        'Банк "Центр-инвест " предлагает индивидуальные условия кредитования для медицинских работников. Дополнительная скидка 0,5% от процентной ставки.',
        'Индивидуальные условия кредитования для работников медицинской сферы',
    ],
    experience: [
        'Корпоративное управление: опыт банка «Центр-инвест» | Информация акционерам и инвесторам банка Центр-инвест',
        'Корпоративное управление: опыт банка «Центр-инвест» | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Корпоративное управление, Полезная информация для акционеров и инвесторов',
    ],
    'international-activity': [
        'Международная деятельность: сотрудничество с банками и МФИ | Информация акционерам и инвесторам банка Центр-инвест',
        'Международная деятельность: сотрудничество с банками и МФИ | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Международная деятельность, Полезная информация для акционеров и инвесторов',
    ],
    'meetings-of-shareholders': [
        'Информация о собраниях акционеров | Информация акционерам и инвесторам банка Центр-инвест',
        'Информация о собраниях акционеров | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Информация о собраниях акционеров, Полезная информация для акционеров и инвесторов',
    ],
    principles: [
        'Системы и принципы корпоративного управления | Информация акционерам и инвесторам банка Центр-инвест',
        'Системы и принципы корпоративного управления | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Системы и принципы корпоративного управления, Полезная информация для акционеров и инвесторов',
    ],
    'pub-info': [
        'Раскрытие информации | Информация акционерам и инвесторам банка Центр-инвест',
        'Раскрытие информации | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Раскрытие информации, Полезная информация для акционеров и инвесторов',
    ],
    'bailee-docs': [
        'Документы депозитария | Информация акционерам и инвесторам банка Центр-инвест',
        'Документы депозитария | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Документы депозитария, Полезная информация для акционеров и инвесторов',
    ],
    'broker-docs': [
        'Документы брокера | Информация акционерам и инвесторам банка Центр-инвест',
        'Документы брокера | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Документы брокера, Полезная информация для акционеров и инвесторов',
    ],
    'cliring-organization': [
        'Перечень клиринговых организаций, с которыми ПАО КБ «Центр-инвест» заключил договоры об оказании ему клиринговых услуг | Информация акционерам и инвесторам банка Центр-инвест',
        'Перечень клиринговых организаций, с которыми ПАО КБ «Центр-инвест» заключил договоры об оказании ему клиринговых услуг | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Перечень клиринговых организаций, Полезная информация для акционеров и инвесторов',
    ],
    'info-regulatory': [
        'Информация о членстве в саморегулируемых организациях | Информация акционерам и инвесторам банка Центр-инвест',
        'Информация о членстве в саморегулируемых организациях | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Информация о членстве в саморегулируемых организациях, Полезная информация для акционеров и инвесторов',
    ],
    'inside-docs': [
        'Внутренние документы | Информация акционерам и инвесторам банка Центр-инвест',
        'Внутренние документы | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Внутренние документы, Полезная информация для акционеров и инвесторов',
    ],
    licenses: [
        'Лицензии | Информация акционерам и инвесторам банка Центр-инвест',
        'Лицензии | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Лицензии, Полезная информация для акционеров и инвесторов',
    ],
    'manager-docs': [
        'Документы доверительного управляющего | Информация акционерам и инвесторам банка Центр-инвест',
        'Документы доверительного управляющего | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Документы доверительного управляющего, Полезная информация для акционеров и инвесторов',
    ],
    'measure-docs': [
        'Перечень мер, направленных на предотвращение конфликта интересов при осуществлении профессиональной деятельности на рынке ценных бумаг | Информация акционерам и инвесторам банка Центр-инвест',
        'Перечень мер, направленных на предотвращение конфликта интересов при осуществлении профессиональной деятельности на рынке ценных бумаг | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Перечень мер, Полезная информация для акционеров и инвесторов',
    ],
    'organiz-torg': [
        'Перечень организаторов торговли, где ПАО КБ «Центр-инвест» является участником торгов | Информация акционерам и инвесторам банка Центр-инвест',
        'Перечень организаторов торговли, где ПАО КБ «Центр-инвест» является участником торгов | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Перечень организаторов торговли, Полезная информация для акционеров и инвесторов',
    ],
    'polojenie-kval': [
        'Положение о порядке признания клиентов квалифицированными инвесторами | Информация акционерам и инвесторам банка Центр-инвест',
        'Положение о порядке признания клиентов квалифицированными инвесторами | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Положение о порядке признания клиентов квалифицированными инвесторами, Полезная информация для акционеров и инвесторов',
    ],
    'registr-depo': [
        'Перечень регистраторов и депозитариев, в которых ПАО КБ «Центр-инвест» открыты лицевые счета (счета депо) доверительного управляющего или номинального держателя | Информация акционерам и инвесторам банка Центр-инвест',
        'Перечень регистраторов и депозитариев, в которых ПАО КБ «Центр-инвест» открыты лицевые счета (счета депо) доверительного управляющего или номинального держателя | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Перечень регистраторов и депозитариев, Полезная информация для акционеров и инвесторов',
    ],
    registrar: [
        'Реестродержатель | Информация акционерам и инвесторам банка Центр-инвест',
        'Реестродержатель | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Реестродержатель, Полезная информация для акционеров и инвесторов',
    ],
    'regulatory-purp': [
        'Раскрытие информации для регулятивных целей | Информация акционерам и инвесторам банка Центр-инвест',
        'Раскрытие информации для регулятивных целей | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Раскрытие информации для регулятивных целей, Полезная информация для акционеров и инвесторов',
    ],
    reports: [
        'Отчеты и публикации | Информация акционерам и инвесторам банка Центр-инвест',
        'Отчеты и публикации | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Отчеты и публикации, Полезная информация для акционеров и инвесторов',
    ],
    shareholders: [
        'Акционеры банка | Информация акционерам и инвесторам банка Центр-инвест',
        'Акционеры банка | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Акционеры банка, Полезная информация для акционеров и инвесторов',
    ],
    'struct-controls': [
        'Структура и органы управления | Информация акционерам и инвесторам банка Центр-инвест',
        'Структура и органы управления | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Структура и органы управления, Полезная информация для акционеров и инвесторов',
    ],
    'board-of-directors': [
        'Совет директоров и Правление | Информация акционерам и инвесторам банка Центр-инвест',
        'Совет директоров и Правление | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Совет директоров и Правление, Полезная информация для акционеров и инвесторов',
    ],
    structure: [
        'Структура управления | Информация акционерам и инвесторам банка Центр-инвест',
        'Структура управления | Полезная информация для акционеров и инвесторов банка «Центр-инвест»',
        'Структура управления, Полезная информация для акционеров и инвесторов',
    ],
    'self-employed-business': [
        'Кредиты для самозанятых граждан на развитие бизнеса | Банк Центр-инвест',
        '&#127974; Взять кредит для самозанятых граждан на выгодных условиях в банке Центр-инвест. Оформите кредит онлайн и получите необходимое финансирование для вашего бизнеса. Подайте заявку прямо сейчас! &#10004;Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'самозанятый кредит, кредит для самозанятых, кредит самозанятым банки, взять кредит самозанятому, кредит для самозанятых граждан, самозанятый кредит на развитие бизнеса, кредит для самозанятых на развитие бизнеса',
    ],
    'smartgrant-application': [
        'Эксклюзивные условия для участников «Умной стипендии» и их близких',
        'Эксклюзивные условия для участников «Умной стипендии» и их близких',
        'Эксклюзивные условия для участников «Умной стипендии» и их близких',
    ],
    press: [
        'Новостной портал банка "Центр-инвест" | Банковские услуги физическим и юридическим лицам',
        'Новостной портал банка "Центр-инвест" | Банковские услуги физическим и юридическим лицам | Подробности на сайте и по телефону 8 800 200 99 29',
        'Новостной портал банка "Центр-инвест", Банковские услуги физическим и юридическим лицам',
    ],
    'psk-oborotnaia-bez-poruchitelstva-msp-korporatsii': [
        'Кредит для пополнения оборотных средств ПСК Оборотная без поручительства МСП Корпорации | Банк "Центр-инвест"',
        'Кредит для пополнения оборотных средств ПСК Оборотная без поручительства МСП Корпорации | Банк "Центр-инвест" | Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит для пополнения оборотных средств ПСК Оборотная без поручительства МСП Корпорации, Банк "Центр-инвест"',
    ],
    'psk-pod-poruchitelstvo-msp-korporatsii': [
        'Кредит для пополнения оборотных средств ПСК под поручительство МСП Корпорации | Банк "Центр-инвест"',
        'Кредит для пополнения оборотных средств ПСК под поручительство МСП Корпорации | Банк "Центр-инвест" | Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит для пополнения оборотных средств ПСК под поручительство МСП Корпорации, Банк "Центр-инвест',
    ],
    'lgotnye-kredity-dlia-importerov': [
        'Льготные кредиты для импортеров | Новостной портал банка "Центр-инвест"',
        'Льготные кредиты для импортеров | Банк "Центр-инвест" | Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготные кредиты для импортеров, Новостной портал банка "Центр-инвест"',
    ],
    'esg-rating': [
        'ESG-оценка компаний от банка Центр-инвест',
        'Оценка ESG-рейтинга компании от банка Центр-инвест. Закажите ESG-оценку вашего бизнеса и получите кешбэк до 5% на расчетно-кассовое обслуживание в Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'ESG-оценка компаний от банка Центр-инвест',
    ],
    'esg-library': [
        'ESG-библиотека | Банк "Центр-инвест"',
        'ESG-библиотека | Банк "Центр-инвест" | Подробности на сайте и по телефону 8 800 200 99 29',
        'ESG-библиотека, Банк "Центр-инвест"',
    ],
    'fz-delay': [
        'Льготный период по 377-ФЗ | Банк "Центр-инвест"',
        'Льготный период по 377-ФЗ | Банк "Центр-инвест" | Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготный период по 377-ФЗ, Банк "Центр-инвест"',
    ],
    'useful-info': [
        'Полезная информация по кредитованию | Банк "Центр-инвест"',
        'Тарифы на обслуживание | Дистанционные методы оплаты | Правила и памятки | Полезная информация по кредитованию | Банк "Центр-инвест"',
        'Полезная информация по кредитованию, Банк "Центр-инвест"',
    ],
    instructionsqrlink: [
        'Инструкции | Банк "Центр-инвест"',
        'Инструкции | Банк "Центр-инвест"',
        'Инструкции, Банк "Центр-инвест"',
    ],
    info: [
        'Клиент-банк | Банк "Центр-инвест" | Новые возможности системы «Клиент-банк» для юридических лиц',
        'Клиент-банк | Банк "Центр-инвест" | Новые возможности системы «Клиент-банк» для юридических лиц',
        'Клиент-банк, Банк "Центр-инвест", Новые возможности системы «Клиент-банк» для юридических лиц',
    ],
    'property-deduction': [
        'Упрощенный налоговый вычет | Банк "Центр-инвест"',
        'Упрощенный налоговый вычет - верните налог с покупки недвижимости и за уплаченные проценты по ипотеку',
        'Упрощенный налоговый вычет, Банк "Центр-инвест"',
    ],
    'short-card-request': [
        'Короткая заявка на выпуск карты | Банк "Центр-инвест"',
        'Короткая заявка на выпуск карты | Банк "Центр-инвест"',
        'Короткая заявка на выпуск карты, Банк "Центр-инвест"',
    ],
    archive: [
        'Архивные курсы валют | Банк "Центр-инвест"',
        'Архивные курсы валют | Банк "Центр-инвест"',
        'Архивные курсы валют, Банк "Центр-инвест"',
    ],
    'green-mortgage': [
        'Зелёная ипотека в банке Центр-инвест',
        '&#10145; Предлагаем взять Зеленую ипотеку в банке Центр-инвест. &#11088; Выгодные условия ипотеки для энергоэффективного жилья. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'зеленая ипотека, условия зеленой ипотеки',
    ],
    'mortgage-2': [
        `Льготная ипотека с господдержкой под ${mortgageTwoPercent.rate}% подать онлайн заявку`,
        `&#10145; В банке Центр-инвест вы можете взять ипотеку под ${mortgageTwoPercent.rate}% (с господдержкой). &#9989; Рассчитать условия ипотечного кредита с господдержкой (ПП РФ 2565) и подать заявку на льготную ипотеку онлайн.`,
        'ипотека с господдержкой, ипотека 2 процента, ипотека под 2 процента, банк ипотека господдержка, льготная ипотека под 2 процента, заявка на ипотеку с господдержкой, подать заявку на ипотеку с господдержкой',
    ],
    mirpass: [
        'Mir Pass | Банк "Центр-инвест"',
        'Mir Pass | Банк "Центр-инвест"',
        'Mir Pass, Банк "Центр-инвест"',
    ],
    'dkbo-docs': [
        'Договор комплексного банковского обслуживания | Тарифы и документы | Банк "Центр-инвест"',
        'Договор комплексного банковского обслуживания | Тарифы и документы | Банк "Центр-инвест"',
        'Договор комплексного банковского обслуживания, Тарифы и документы, Банк "Центр-инвест"',
    ],
    'cards-docs': [
        'Документы по банковским картам | Тарифы и документы | Банк "Центр-инвест"',
        'Документы по банковским картам | Тарифы и документы | Банк "Центр-инвест"',
        'Документы по банковским картам, Тарифы и документы, Банк "Центр-инвест"',
    ],
    'internet-bank-docs': [
        'Документы для интернет банка | Тарифы и документы | Банк "Центр-инвест"',
        'Документы для интернет банка | Тарифы и документы | Банк "Центр-инвест"',
        'Документы для интернет банка, Тарифы и документы, Банк "Центр-инвест"',
    ],
    'mobile-bank-docs': [
        'Документы для мобильного банка | Тарифы и документы | Банк "Центр-инвест"',
        'Документы для мобильного банка | Тарифы и документы | Банк "Центр-инвест"',
        'Документы для мобильного банка, Тарифы и документы, Банк "Центр-инвест"',
    ],
    'promyshlennaia-ipoteka': [
        'Промышленная ипотека | Банк "Центр-инвест"',
        'Промышленная ипотека | Банк "Центр-инвест"',
        'Промышленная ипотека, Банк "Центр-инвест"',
    ],
    'bank-agreement': [
        'Согласие БКИ | Банк "Центр-инвест"',
        'Согласие БКИ | Банк "Центр-инвест"',
        'Согласие БКИ, Банк "Центр-инвест"',
    ],
    start: [
        'Начальная страница | Банк "Центр-инвест"',
        'Начальная страница | Банк "Центр-инвест"',
        'Начальная страница, Банк "Центр-инвест"',
    ],
    'servisnaia-karta-mir': [
        'Сервисная карта мир для физических лиц | Банк Центр-инвест',
        'Сервисная карта мир для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Сервисная карта мир для физических лиц',
    ],
    dbo: [
        'Интерактивные инструкции | Банк "Центр-инвест"',
        'Интерактивные инструкции | Банк "Центр-инвест"',
        'Интерактивные инструкции, Банк "Центр-инвест"',
    ],
    'check-your-app': [
        'Проверка приложения банка "Центр-инвест" | Банк "Центр-инвест"',
        'Проверка приложения банка "Центр-инвест" | Банк "Центр-инвест"',
        'Проверка приложения банка "Центр-инвест", Банк "Центр-инвест"',
    ],
    history: [
        'История здания головного офиса банка «Центр-инвест» | Банк "Центр-инвест"',
        'История здания головного офиса банка «Центр-инвест» | Банк "Центр-инвест"',
        'История здания головного офиса банка «Центр-инвест», Банк "Центр-инвест"',
    ],
    'mir-child': [
        'Детская карта для физических лиц | Банк Центр-инвест',
        'Детская карта для физических лиц. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Детская карта для физических лиц',
    ],
    fz106: [
        'Льготный период 106-ФЗ и реструктуризация кредитов для бизнеса | Банк Центр-инвест',
        'Льготный период 106-ФЗ и реструктуризация кредитов для бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Льготный период 106-ФЗ и реструктуризация кредитов для бизнеса',
    ],
    wifi: [
        'Оформите универсальную карту в банке Центр-инвест | Банк Центр-инвест',
        'Подключитесь к вайфаю в отделениях нашего банка | ПАО коммерческий банк Центр-инвест',
        'Банк Центр-инвест',
    ],
    'googlepay-mir': [
        'Быстро и удобно c картой «Мир» и Google Pay | Банк "Центр-инвест"',
        'Быстро и удобно c картой «Мир» и Google Pay | Банк "Центр-инвест"',
        'Банк "Центр-инвест"',
    ],
    fz377: [
        'Льготный период по 377-ФЗ, 406-ФЗ | Банк "Центр-инвест"',
        'Льготный период по 377-ФЗ, 406-ФЗ | Банк "Центр-инвест"',
        'Льготный период по 377-ФЗ, 406-ФЗ, Банк "Центр-инвест"',
    ],
    'western-union': [
        'Переводы по сиcтеме «Western Union» | Банк "Центр-инвест"',
        'Переводы по сиcтеме «Western Union» | Банк "Центр-инвест"',
        'Переводы по сиcтеме «Western Union», Банк "Центр-инвест"',
    ],
    payments: [
        'Платежи | Банк "Центр-инвест"',
        'Платежи | Банк "Центр-инвест"',
        'Платежи, Банк "Центр-инвест"',
    ],
    avto: [
        'Оформите кредит наличными | Банк "Центр-инвест"',
        'Оформите кредит наличными | Банк "Центр-инвест"',
        'Кредит наличными, Банк "Центр-инвест"',
    ],
    mosprime: [
        'Ипотека с MosPrime | Банк "Центр-инвест"',
        'Замена индикатора MosPrime Rate на индикатор Ключевая ставка Банка России с 30 июня 2023',
        'Ипотека с MosPrime, Банк "Центр-инвест"',
    ],
    'presentation-information': [
        'Уведомление клиентов | Банк "Центр-инвест"',
        'Уведомление клиентов | Банк "Центр-инвест"',
        'Уведомление клиентов, Банк "Центр-инвест"',
    ],
    'car-charging': [
        'Зарядите ваш электромобиль | Банк "Центр-инвест"',
        'Зарядите ваш электромобиль | Банк "Центр-инвест"',
        'Зарядите ваш электромобиль, Банк "Центр-инвест"',
    ],
    sticker: [
        'Платежные стикеры | Банк "Центр-инвест"',
        'Платежные стикеры | Банк "Центр-инвест"',
        'Платежные стикеры, Банк "Центр-инвест"',
    ],
    unsubscribe: [
        'Отписка от рассылки | Банк "Центр-инвест"',
        'Отписка от рассылки | Банк "Центр-инвест"',
        'Отписка от рассылки, Банк "Центр-инвест"',
    ],
    'payment-qr': [
        'Прием платежей по QR-коду | Банк Центр-инвест',
        '&#127974; Прием и оплата платежей через QR-код для вашего бизнеса от банка Центр-инвест. &#10004; Просто и безопасно принимайте оплату с нашей помощью. Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'прием платежей по qr, прием платежей по qr коду, прием оплаты qr, прием оплаты по qr коду, прием платежей через qr, прием платежей через qr код, прием оплаты через qr код, qr code для приема платежей',
    ],
    'mortgage-excellent-student': [
        'Ипотека для отличников',
        'Ипотека для отличников.',
        'Ипотека для отличников',
    ],
    'pari-n-n': [
        '«Пари Нижний Новгород» Клубная карта | Банк Центр-инвест',
        '«Пари Нижний Новгород» Клубная карта | Банк Центр-инвест | 12% годовых на остаток по карте | Платежная система "Мир"',
        '«Пари Нижний Новгород» Клубная карта | Банк Центр-инвест',
    ],
    'large-family': [
        'Оформить ипотеку для многодетных семей в банке Центр-инвест — онлайн заявка на ипотеку для многодетных 2025',
        'Взять ипотеку для многодетных семей в 2025 на выгодных условиях в банке Центр-инвест. Онлайн оформление заявки на льготную ипотеку для многодетных. &#9989; Рассчитать ипотеку онлайн и подать заявку можно на сайте. &#11088; Подробности по телефону &#9742; 8 800 200 99 29',
        'Снижаем процент по ипотеке для многодетных семей',
    ],
    'car-loan': [
        'Кредит наличными на приобретение автомобиля | Банк Центр-инвест',
        'Кредит наличными на приобретение автомобиля. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Кредит наличными на приобретение автомобиля',
    ],
    'starting-business': [
        'Программы для начинающего бизнеса | Банк Центр-инвест',
        'Программы для начинающего бизнеса. Выгодные предложения от банка Центр-инвест. Подробности на сайте и по телефону 8 800 200 99 29',
        'Программы для начинающего бизнеса',
    ],
    'bank-management': [
        'Сведения о лицах, входящих в состав органов управления банка, и иных должностных лицах банка',
        'Сведения о лицах, входящих в состав органов управления банка, и иных должностных лицах банка | Информация акционерам и инвесторам банка Центр-инвест',
        'информация для акционеров, информация для инвесторов',
    ],
    'mortgage-combo': [
        'Комбо-ипотека для приобретения недвижимости, расположенной на&nbsp;территории в&nbsp;г. Москвы, Московской области',
        'Комбо-ипотека для приобретения недвижимости, расположенной на&nbsp;территории в&nbsp;г. Москвы, Московской области',
        'Комбо-ипотека для приобретения недвижимости, расположенной на&nbsp;территории в&nbsp;г. Москвы, Московской области',
    ],
    fccn: [
        'Клубная карта «Черноморец» | Банк Центр-инвест',
        'Клубная карта «Черноморец» | Банк Центр-инвест | 12% годовых на остаток по карте | Платежная система "Мир"',
        'Клубная карта «Черноморец» | Банк Центр-инвест',
    ],
    'support-measures': [
        'Помощь гражданам Курской, Брянской и Белгородской областей | Банковские услуги физическим и юридическим лицам в банке «Центр-инвест»',
        'Помощь гражданам Курской, Брянской и Белгородской областей | ПАО коммерческий банк «Центр-инвест»',
        'Помощь гражданам Курской, Брянской и Белгородской областей | ПАО коммерческий банк «Центр-инвест»',
    ],
    'online-cashbox-free': [
        'Бесплатная онлайн-касса 54-ФЗ: простое решение для приема платежей от банка «Центр-инвест»',
        '«Центр-инвест» предлагает бесплатную онлайн-кассу под 54-ФЗ для торговли с полным набором функций для вашего бизнеса. Быстрая настройка, удобный интерфейс, экономия на кассовом обслуживании. Подключите бесплатно! Подробности на сайте и по телефону &#9742; 8 800 200 99 29',
        'Бесплатная онлайн-касса 54-ФЗ: простое решение для приема платежей от банка «Центр-инвест»',
    ],
    'real-estate-valuation': [
        'Оценка недвижимости в банке «Центр-инвест»',
        'Оценка недвижимости | ПАО коммерческий банк «Центр-инвест»',
        'Оценка недвижимости | ПАО коммерческий банк «Центр-инвест»',
    ],
    'fz-potreb': [
        'Льготный период по 377-ФЗ: Как использовать налоговые льготы и снизить расходы',
        'Льготный период по 377-ФЗ – узнайте, как воспользоваться преимуществами и снизить финансовую нагрузку. Подробная информация о налоговых льготах и условиях для бизнеса в банке «Центр-инвест»',
        'Льготный период по 377-ФЗ: Как использовать налоговые льготы и снизить расходы',
    ],
    'supreme-plus-credit': [
        'Кредитная карта Mir Supreme+ с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
        'Оформить кредитную карту Mir Supreme+ с кредитным лимитом от банка «Центр-инвест». Бесплатный выпуск платежного стикера, до 55 дней без % на покупки, переводы и снятие наличных. Оставьте заявку на кредитку на сайте или позвоните по телефону &#9742; 8 800 200 99 29',
        'Кредитная карта Mir Supreme+ с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
    ],
    'supreme-credit': [
        'Кредитная карта Mir Supreme с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
        'Оформить кредитную карту Mir Supreme с кредитным лимитом от банка «Центр-инвест». Бесплатный выпуск платежного стикера, до 55 дней без % на покупки, переводы и снятие наличных. Оставьте заявку на кредитку на сайте или позвоните по телефону &#9742; 8 800 200 99 29',
        'Кредитная карта Mir Supreme с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
    ],
    'salary-credit': [
        'Зарплатная карта с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
        'Оформить зарплатную карту с кредитным лимитом от банка «Центр-инвест». Бесплатный выпуск и обслуживание карты, автоматическая пролонгация и погашение. Оставьте заявку на кредитку на сайте или позвоните по телефону &#9742; 8 800 200 99 30',
        'Зарплатная карта с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
    ],
    'advanced-credit': [
        'Продвинутая карта с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
        'Оформить продвинутую карту с кредитным лимитом от банка «Центр-инвест». Бесплатный выпуск и обслуживание карты, до 55 дней без % на покупки, переводы и снятие наличных. Оставьте заявку на кредитку на сайте или позвоните по телефону &#9742; 8 800 200 99 30',
        'Продвинутая карта с кредитным лимитом оформить онлайн в банке «Центр-инвест»',
    ],
    'student-card': [
        'Студенческая карта оформить онлайн в банке «Центр-инвест»',
        'Студенческая карта в банке «Центр-инвест». Кампусная карта для студентов вузов-партнеров. Бесплатный выпуск и обслуживание карты. Кешбэк у партнеров до 30%',
        'Студенческая карта оформить онлайн в банке «Центр-инвест»',
    ],
    'financial-commissioner': [
        'Финансовый уполномоченный | Банковские услуги физическим и юридическим лицам в банке «Центр-инвест»',
        'Служба финансового уполномоченного по правам потребителей финансовых услуг | ПАО коммерческий банк «Центр-инвест»',
        'Служба финансового уполномоченного по правам потребителей финансовых услуг | ПАО коммерческий банк «Центр-инвест»',
    ],
    'tsvetushchii-gorod': [
        'Кредит «Цветущий город» | Коммерческий банк «Центр-инвест»',
        'Кредитование Цветущий город – выгодные условия для малого и среднего бизнеса. Получите финансирование на развитие проектов и бизнеса с низкими процентными ставками и гибкими условиями в банке «Центр-инвест»',
        'Кредит «Цветущий город» | Коммерческий банк «Центр-инвест»',
    ],
    'web-tsp': [
        'ВебТСП - прием оплат через QR-код для бизнеса',
        'ВебТСП - прием оплат через QR-код для бизнеса | ПАО коммерческий банк «Центр-инвест»',
        'ВебТСП - прием оплат через QR-код для бизнеса | ПАО коммерческий банк «Центр-инвест»',
    ],
    'transfer-b2b': [
        'B2B переводы через Систему быстрых платежей (СБП) в банке «Центр-инвест»',
        'Мгновенные B2B переводы в банке «Центр-инвест». Упростите бизнес-транзакции с нашими мгновенными переводами B2B. Быстрые, безопасные и удобные решения для расчетов. Подключите услугу B2B переводов на сайте или по телефону &#9742; 8 800 200 99 29',
        'B2B переводы через Систему быстрых платежей (СБП) в банке «Центр-инвест»',
    ],
    'internet-acquiring': [
        'Интернет-эквайринг для бизнеса в банке «Центр-инвест» — Подключить интернет-эквайринг',
        'Интернет-эквайринг в банке «Центр-инвест». Быстрое подключение услуги онлайн-эквайринга для бизнеса. Безопасность платежей, раннее зачисление средств на расчетный счет. Оформить заявку на подключение интернет-эквайринга на сайте или по телефону &#9742; 8 800 200 99 29',
        'Интернет-эквайринг для бизнеса в банке «Центр-инвест» — Подключить интернет-эквайринг',
    ],
    'pod-poruchitelstvo-regionalnoi-garantiinoi-organizatsii': [
        'Кредит под поручительство региональной гарантийной организации | Коммерческий банк «Центр-инвест»',
        'Поручительство региональной гарантийной организации в размере 70% от суммы кредита | ПАО коммерческий банк «Центр-инвест»',
        'Поручительство региональной гарантийной организации в размере 70% от суммы кредита | ПАО коммерческий банк «Центр-инвест»',
    ],
    'na-priobretenie-selkhoztekhniki-avtotransporta-oborudovaniia': [
        'Кредит на приобретение сельхозтехники, автотранспорта, оборудования | Коммерческий банк «Центр-инвест» ',
        'Оформить кредит на приобретение сельхозтехники, автотранспорта, оборудования | ПАО коммерческий банк «Центр-инвест»',
        'Оформить кредит на приобретение сельхозтехники, автотранспорта, оборудования | ПАО коммерческий банк «Центр-инвест»',
    ],
    'finansirovanie-kooperatsionnykh-proektov': [
        'Финансирование кооперационных проектов | Коммерческий банк «Центр-инвест»',
        'Финансирование кооперационных проектов в отраслях промышленности содействующих со странами ЕАЭС | ПАО коммерческий банк «Центр-инвест»',
        'Финансирование кооперационных проектов в отраслях промышленности содействующих со странами ЕАЭС | ПАО коммерческий банк «Центр-инвест»',
    ],
    'kred-organization': [
        'Информация о кредитных организациях | Коммерческий банк «Центр-инвест»',
        'Информация о кредитных организациях, в которых ПАО КБ  «Центр-инвест» открыты банковские счета для расчетов по операциям, совершаемым в рамках деятельности по управлению ценными бумагами | ПАО коммерческий банк «Центр-инвест»',
        'Информация о кредитных организациях | Коммерческий банк «Центр-инвест»',
    ],
    'bank-info': [
        'Информация о банке | Коммерческий банк «Центр-инвест»',
        'Информация о банке | ПАО коммерческий банк «Центр-инвест»',
        'Информация о банке | ПАО коммерческий банк «Центр-инвест»',
    ],
    form: [
        'Данные о кредите | Коммерческий банк «Центр-инвест»',
        'Данные о кредите. Банковские услуги юридическим и физическим лицам | ПАО коммерческий банк «Центр-инвест»',
        'Данные о кредите. Банковские услуги юридическим и физическим лицам | ПАО коммерческий банк «Центр-инвест»',
    ],
}));

export {metaParams};
